import { Messages } from '~src/codegen/Localize';

import { RegexBasedPasswordPolicy } from './RegexBasedPasswordPolicy';

export class MustContainUppercaseLettersPolicy extends RegexBasedPasswordPolicy {

    private static instance: MustContainUppercaseLettersPolicy = new MustContainUppercaseLettersPolicy();

    private constructor() {
        super(/[A-Z]/);
    }

    public static getPolicy(): MustContainUppercaseLettersPolicy {
        return MustContainUppercaseLettersPolicy.instance;
    }

    public getErrorMessage(): string {
        return Messages.passwordPolicies_mustContainUppercaseLetters();
    }

    public getTestId(): string {
        return MustContainUppercaseLettersPolicy.name;
    }
}
